import styled from 'styled-components'

export const Section = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  border: 0.91px solid #e2e2e2;
  opacity: 1;

  h2 {
    font-size: 1.6rem !important;
    font-weight: 600;
    color: #2c2c2c;
    margin: 0;
  }

  .section-subtitle {
    font-size: 1.2rem !important;
    font-weight: 400;
    color: #4d4d4d;
    margin-top: 4px;
  }
`

export const TableWrapper = styled.div`
  margin: 20px -20px 0;
  border-top: 0.91px solid #e2e2e2;
  overflow-x: auto;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    text-align: left;
    padding: 12px 20px;
    white-space: nowrap;
  }

  th {
    font-size: 1.2rem !important;
    font-weight: 600;
    color: #4d4d4d;
    border-bottom: 1px solid #e2e2e2;
  }

  td {
    font-size: 1.4rem !important;
    font-weight: 400;
    color: #4d4d4d;
    border-bottom: 1px solid #f0f0f0;
  }
`

export const MonthCell = styled.td`
  font-weight: 700 !important;
  color: #2c2c2c !important;
  text-transform: capitalize;
`

export const TotalValueCell = styled.td`
  font-weight: 700 !important;
  color: #2c2c2c !important;
`

export const StatusBadge = styled.span<{ color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 1.2rem !important;
  font-weight: 600;
  color: ${({ color }) => color};
`

export const Dot = styled.span<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex-shrink: 0;
`

export const ViewDetailsButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 1.6rem !important;
  font-weight: 400;
  color: #8660ec;
  cursor: pointer;
  text-transform: none;
`

export const EmptyState = styled.div`
  padding: 24px 0;
  text-align: center;
  font-size: 1.4rem !important;
  color: ${({ theme }) => theme.colors.gray80};
`
